import { managerFactory } from "@/factories/manager";
import {
  initializeBackendApiClient,
  initializeBackendAuthApiClient,
  initializeServiceInfoApiClient,
} from "@/manager/backend-api-client/initializeBackendApiManager";

export const backendApiClientManager = managerFactory.create({
  initializer: initializeBackendApiClient,
});

export const backendAuthApiClientManager = managerFactory.create({
  initializer: initializeBackendAuthApiClient,
});

export const serviceInfoApiClientManager = managerFactory.create({
  initializer: initializeServiceInfoApiClient,
});

export type BackendApiClient = ReturnType<(typeof backendApiClientManager)["instance"]>;
